export default {
    commonDictionary: {
        allergies: [],
        foodHandling: [],
        diet: [],
        accommodationProvided: [],
        insurancePlanChosen: [],
        applicationType: [],
        applicationTo: [],
        incomeUse: [],
        contractHolidayOff: [],
        relationship: [],
        incomeSupportingDocs: [],
        cleaningTypeWindow: [],
        contractType: [],
        idType: [],
        contractStatus: [],
        releasePaperPass: [],
    },
    dictionary: {
        nationality: [],        // employer所属国家
        age: [],                // 年龄范围
        caringSkills: [],       // 照顾人的技能
        languageSkills: [],     // 语言技能
        cookingSkills: [],      // 烹饪技能
        otherSkills: [],        // 其他技能
        roomType: [],           // 房间类型
        religion: [],           // 宗教
        maritalStatus: [],      // 婚姻状态
        educationLevel: [],     // 教育水平
        haveChild: [],          // 是否有孩子
        apartmentType: [],      // 公寓类型
        haveCaregiverDiploma: [],   // 是否有证书 multiSelectString
        helperNationality: [],      // helper所属的国家
        workingExperienceIn: [],    // helper工作的国家
        currentStatus: [],      // helper状态
        race: [],               // 种族
        keyWord: [],            // helper关键词
        interviewStatus: [],    // 面试状态
        interviewResult: [],    // 面试结果
        label: [],              // helper标签
        employerStatus: [],     // 雇主状态
        workDuty: [],           // helper工作历史的workDuty
        residential: [],        // employer residential status
        country: [],            // 国家name
    },
    supportCountryMap: [],
    supportEmployerCountryMap: [],
    helperCreatorMap: [],
    agencyCountryMap: [
        {
            countryCode: 'MY',
            countryName: 'Malaysia',
            countryId: 1129,
        },
        {
            countryCode: 'SG',
            countryName: 'Singapore',
            countryId: 1192,
        },
        {
            countryCode: 'HK',
            countryName: 'Hong Kong',
            countryId: 1098,
        },
        {
            countryCode: 'MO',
            countryName: 'Macao',
            countryId: 1126,
        },
        {
            countryCode: 'TW',
            countryName: 'Taiwan',
            countryId: 1210,
        },
        {
            countryCode: 'SA',
            countryName: 'Saudi Arabia',
            countryId: 1187,
        },
        {
            countryCode: 'UAE',
            countryName: 'United Arab Emirates',
            countryId: 1225,
        },
        // {
        //     countryCode: 'CN',
        //     countryName: 'China',
        //     countryId: 1045,
        // },
        {
            countryCode: 'OM',
            countryName: 'Oman',
            countryId: 1163,
        },
        {
            countryCode: 'QA',
            countryName: 'Qatar',
            countryId: 1176,
        },
    ],
    onlineStatusMap: [],
    allHelperTypeMap: [],
    helperCurrencyUnitMap: {
        302: '₱',
        1102: 'Rp',
        1147: 'K',
    },
    helperTypeMap: [],
    helperCountryMap: [{
        name: 'Philippines',
        code: 'PH',
        value: 302,
    }, {
        name: 'Indonesian',
        code: 'ID',
        value: 1102,
    }, {
        name: 'Myanmar',
        code: 'MM',
        value: 1147,
    }, {
        name: 'Indian',
        code: 'IN',
        value: 1101,
    }, {
        name: 'Malaysian',
        code: 'MY',
        value: 1129,
    }, {
        name: 'Hong Konger/Chinese',
        code: 'HK',
        value: 9999,
    }, {
        name: 'Macanese/Chinese',
        code: 'MO',
        value: 121,
    }, {
        name: 'Taiwanese',
        code: 'TW',
        value: 457,
    }, {
        name: 'South Korean',
        code: 'KP',
        value: 1198,
    }, {
        name: 'Bangladeshi',
        code: 'BD',
        value: 541,
    }, {
        name: 'Cambodian',
        code: 'CB',
        value: 1037,
    }, {
        name: 'Sri Lankan',
        code: 'LK',
        value: 1200,
    }, {
        name: 'Thai',
        code: 'TH',
        value: 307,
    }, {
        name: 'Other Countries',
        code: 'OT',
        value: 0,
    }],
    skillExperienceMap: [],
    employerDataSourceMap: ['Self-registration', 'Walk-in', 'Call-in', 'WhatsApp', 'Email', 'Facebook', 'Friend Referral', 'Netmaid', 'Bestmaid', 'Partner Channel'],
    helperDataSourceMap: ['Supplier', 'Friend Referral', 'Employer', 'Direct Hire', 'Co-broke', 'Walk-in', 'Call-in', 'WhatsApp', 'Facebook', 'Self-registration'],
    interviewCreatorMap: [],
    managerMap: [],
    haveChildMap: [],
    yesNoMap: [],
    yesNoBoolMap: [],
    enableMap: [],
    enableBoolMap: [],
    haveOrNotMap: [],
    haveOrNotBoolMap: [],
    exclusiveOrNotMap: [],
    privateRoomMap: [],
    holidayOffMap: [],
    havePetsMap: [],
    offReasonMap: [],
    interviewTypeMap: [],
    birthPlaceList: [],
    titleMap: [],
    languageMap: [{
        name: 'En',
        value: 'en_SG',
    }, {
        name: 'zh_CN',
        value: 'zh_CN',
    }],
    genderMap: [],
    heightMap: [{
        name: '135cm (4\'5\'\')',
        value: 135,
    }, {
        name: '136cm (4\'6\'\')',
        value: 136,
    }, {
        name: '137cm (4\'6\'\')',
        value: 137,
    }, {
        name: '138cm (4\'6\'\')',
        value: 138,
    }, {
        name: '139cm (4\'7\'\')',
        value: 139,
    }, {
        name: '140cm (4\'7\'\')',
        value: 140,
    }, {
        name: '141cm (4\'8\'\')',
        value: 141,
    }, {
        name: '142cm (4\'8\'\')',
        value: 142,
    }, {
        name: '143cm (4\'8\'\')',
        value: 143,
    }, {
        name: '144cm (4\'9\'\')',
        value: 144,
    }, {
        name: '145cm (4\'9\'\')',
        value: 145,
    }, {
        name: '146cm (4\'9\'\')',
        value: 146,
    }, {
        name: '147cm (4\'10\'\')',
        value: 147,
    }, {
        name: '148cm (4\'10\'\')',
        value: 148,
    }, {
        name: '149cm (4\'11\'\')',
        value: 149,
    }, {
        name: '150cm (4\'11\'\')',
        value: 150,
    }, {
        name: '151cm (4\'11\'\')',
        value: 151,
    }, {
        name: '152cm (4\'12\'\')',
        value: 152,
    }, {
        name: '153cm (5\'0\'\')',
        value: 153,
    }, {
        name: '154cm (5\'1\'\')',
        value: 154,
    }, {
        name: '155cm (5\'1\'\')',
        value: 155,
    }, {
        name: '156cm (5\'1\'\')',
        value: 156,
    }, {
        name: '157cm (5\'2\'\')',
        value: 157,
    }, {
        name: '158cm (5\'2\'\')',
        value: 158,
    }, {
        name: '159cm (5\'3\'\')',
        value: 159,
    }, {
        name: '160cm (5\'3\'\')',
        value: 160,
    }, {
        name: '161cm (5\'3\'\')',
        value: 161,
    }, {
        name: '162cm (5\'4\'\')',
        value: 162,
    }, {
        name: '163cm (5\'4\'\')',
        value: 163,
    }, {
        name: '164cm (5\'5\'\')',
        value: 164,
    }, {
        name: '165cm (5\'5\'\')',
        value: 165,
    }, {
        name: '166cm (5\'5\'\')',
        value: 166,
    }, {
        name: '167cm (5\'6\'\')',
        value: 167,
    }, {
        name: '168cm (5\'6\'\')',
        value: 168,
    }, {
        name: '169cm (5\'7\'\')',
        value: 169,
    }, {
        name: '170cm (5\'7\'\')',
        value: 170,
    }, {
        name: '171cm (5\'7\'\')',
        value: 171,
    }, {
        name: '172cm (5\'8\'\')',
        value: 172,
    }, {
        name: '173cm (5\'8\'\')',
        value: 173,
    }, {
        name: '174cm (5\'9\'\')',
        value: 174,
    }, {
        name: '175cm (5\'9\'\')',
        value: 175,
    }],
    weightMap: [{
        name: '35kg (77 lbs)',
        value: 35,
    }, {
        name: '36kg (79 lbs)',
        value: 36,
    }, {
        name: '37kg (82 lbs)',
        value: 37,
    }, {
        name: '38kg (84 lbs)',
        value: 38,
    }, {
        name: '39kg (86 lbs)',
        value: 39,
    }, {
        name: '40kg (88 lbs)',
        value: 40,
    }, {
        name: '41kg (90 lbs)',
        value: 41,
    }, {
        name: '42kg (93 lbs)',
        value: 42,
    }, {
        name: '43kg (95 lbs)',
        value: 43,
    }, {
        name: '44kg (97 lbs)',
        value: 44,
    }, {
        name: '45kg (99 lbs)',
        value: 45,
    }, {
        name: '46kg (101 lbs)',
        value: 46,
    }, {
        name: '47kg (104 lbs)',
        value: 47,
    }, {
        name: '48kg (106 lbs)',
        value: 48,
    }, {
        name: '49kg (108 lbs)',
        value: 49,
    }, {
        name: '50kg (110 lbs)',
        value: 50,
    }, {
        name: '51kg (112 lbs)',
        value: 51,
    }, {
        name: '52kg (115 lbs)',
        value: 52,
    }, {
        name: '53kg (117 lbs)',
        value: 53,
    }, {
        name: '54kg (119 lbs)',
        value: 54,
    }, {
        name: '55kg (121 lbs)',
        value: 55,
    }, {
        name: '56kg (123 lbs)',
        value: 56,
    }, {
        name: '57kg (126 lbs)',
        value: 57,
    }, {
        name: '58kg (128 lbs)',
        value: 58,
    }, {
        name: '59kg (130 lbs)',
        value: 59,
    }, {
        name: '60kg (132 lbs)',
        value: 60,
    }, {
        name: '61kg (134 lbs)',
        value: 61,
    }, {
        name: '62kg (137 lbs)',
        value: 62,
    }, {
        name: '63kg (139 lbs)',
        value: 63,
    }, {
        name: '64kg (141 lbs)',
        value: 64,
    }, {
        name: '65kg (143 lbs)',
        value: 65,
    }, {
        name: '66kg (146 lbs)',
        value: 66,
    }, {
        name: '67kg (148 lbs)',
        value: 67,
    }, {
        name: '68kg (150 lbs)',
        value: 68,
    }, {
        name: '69kg (152 lbs)',
        value: 69,
    }, {
        name: '70kg (154 lbs)',
        value: 70,
    }, {
        name: '71kg (157 lbs)',
        value: 71,
    }, {
        name: '72kg (159 lbs)',
        value: 72,
    }, {
        name: '73kg (161 lbs)',
        value: 73,
    }, {
        name: '74kg (163 lbs)',
        value: 74,
    }, {
        name: '75kg (165 lbs)',
        value: 75,
    }, {
        name: '76kg (168 lbs)',
        value: 76,
    }, {
        name: '77kg (170 lbs)',
        value: 77,
    }, {
        name: '78kg (172 lbs)',
        value: 78,
    }, {
        name: '79kg (174 lbs)',
        value: 79,
    }, {
        name: '80kg (176 lbs)',
        value: 80,
    }, {
        name: '81kg (179 lbs)',
        value: 81,
    }, {
        name: '82kg (181 lbs)',
        value: 82,
    }, {
        name: '83kg (183 lbs)',
        value: 83,
    }, {
        name: '84kg (185 lbs)',
        value: 84,
    }, {
        name: '85kg (187 lbs)',
        value: 85,
    }, {
        name: '86kg (190 lbs)',
        value: 86,
    }, {
        name: '87kg (192 lbs)',
        value: 87,
    }, {
        name: '88kg (194 lbs)',
        value: 88,
    }, {
        name: '89kg (196 lbs)',
        value: 89,
    }, {
        name: '90kg (198 lbs)',
        value: 90,
    }, {
        name: '91kg (201 lbs)',
        value: 91,
    }, {
        name: '92kg (203 lbs)',
        value: 92,
    }, {
        name: '93kg (205 lbs)',
        value: 93,
    }, {
        name: '94kg (207 lbs)',
        value: 94,
    }, {
        name: '95kg (209 lbs)',
        value: 95,
    }, {
        name: '96kg (212 lbs)',
        value: 96,
    }, {
        name: '97kg (214 lbs)',
        value: 97,
    }, {
        name: '98kg (216 lbs)',
        value: 98,
    }, {
        name: '99kg (218 lbs)',
        value: 99,
    }, {
        name: '100kg (220 lbs)',
        value: 100,
    }, {
        name: '101kg (223 lbs)',
        value: 101,
    }, {
        name: '102kg (225 lbs)',
        value: 102,
    }, {
        name: '103kg (227 lbs)',
        value: 103,
    }, {
        name: '104kg (229 lbs)',
        value: 104,
    }, {
        name: '105kg (231 lbs)',
        value: 105,
    }, {
        name: '106kg (234 lbs)',
        value: 106,
    }, {
        name: '107kg (236 lbs)',
        value: 107,
    }, {
        name: '108kg (238 lbs)',
        value: 108,
    }, {
        name: '109kg (240 lbs)',
        value: 109,
    }, {
        name: '110kg (243 lbs)',
        value: 110,
    }],
    restDayMap: [],
    contractPdfNameMap: [{
        title: 'Job Offer',
        name: 'Job Offer.pdf',
        value: 'jobOffer',
        signLinkList: ['sign_employer', 'sign_helper', 'sign_agency', 'sign_ipa_agency'],
    }, {
        title: 'Authorisation Letter',
        name: 'Authorisation Letter.pdf',
        value: 'authorisationLetter',
        signLinkList: ['sign_employer', 'sign_helper'],
    }, {
        title: 'Bio Data Form',
        name: 'Bio Data Form.pdf',
        value: 'bioData',
        signLinkList: ['sign_employer', 'sign_helper', 'sign_agency'],
    }, {
        title: 'MOM Employment History(old, before wp issuance)',
        name: 'MOM Employment History(old, before wp issuance).pdf',
        value: 'MOMEmploymentHistoryOld',
        signLinkList: ['sign_employer', 'sign_helper', 'sign_agency'],
    }, {
        title: 'PDPA',
        name: 'PDPA.pdf',
        value: 'PDPA',
        signLinkList: ['sign_employer'],
    }, {
        title: 'Package Fee (Ordinary)',
        name: 'Package Fee (Ordinary).pdf',
        value: 'packageFeeOrdinary',
        signLinkList: ['sign_employer', 'sign_agency'],
    }, {
        title: 'Service Agreement (Ordinary)',
        name: 'Service Agreement (Ordinary).pdf',
        value: 'serviceAgreementOrdinary',
        signLinkList: ['sign_employer', 'sign_agency'],
    }, {
        title: 'MOM Authorisation Form (Application)',
        name: 'MOM Authorisation Form (Application).pdf',
        value: 'MOMAuthorisationForm',
        signLinkList: ['sign_employer', 'sign_agency'],
    }, {
        title: 'MOM Authorisation Form (Renewal)',
        name: 'MOM Authorisation Form (Renewal).pdf',
        value: 'MOMAuthorisationFormRenewal',
        signLinkList: ['sign_employer', 'sign_agency'],
    }, {
        title: 'Application Form',
        name: 'Application Form.pdf',
        value: 'applicationForm',
        signLinkList: ['sign_employer'],
    }, {
        title: 'Sponsor Details',
        name: 'Sponsor Details.pdf',
        value: 'sponsorDetails',
        signLinkList: ['sign_sponsor_1', 'sign_sponsor_2'],
    }, {
        title: 'Joint Applicant',
        name: 'Joint Applicant.pdf',
        value: 'jointApplicant',
        signLinkList: ['sign_joint'],
    }, {
        title: 'Income Tax Declaration (Standard Application)',
        name: 'Income Tax Declaration (Standard Application).pdf',
        value: 'incomeTaxDeclaration',
        signLinkList: ['sign_employer', 'sign_sponsor'],
    }, {
        title: 'Income Tax Declaration (Sponsorship)',
        name: 'Income Tax Declaration (Sponsorship).pdf',
        value: 'incomeTaxDeclarationSponsorship',
        signLinkList: ['sign_sponsor_1', 'sign_sponsor_2'],
    }, {
        title: 'Income Tax Declaration (Joint Application)',
        name: 'Income Tax Declaration (Joint Application).pdf',
        value: 'incomeTaxDeclarationJointApplication',
        signLinkList: ['sign_employer', 'sign_joint'],
    }, {
        title: 'Package Fee (Replacement)',
        name: 'Package Fee (Replacement).pdf',
        value: 'packageFeeReplacement',
        signLinkList: ['sign_employer', 'sign_agency'],
    }, {
        title: 'Package Fee (Admin)',
        name: 'Package Fee (Admin).pdf',
        value: 'packageFeeAdmin',
        signLinkList: ['sign_employer', 'sign_agency'],
    }, {
        title: 'Form A',
        name: 'Form A.pdf',
        value: 'formA',
        signLinkList: ['sign_employer', 'sign_agency'],
    }, {
        title: 'POEA - Employment Contract',
        name: 'POEA - Employment Contract.pdf',
        value: 'PoeaEmploymentContract',
        signLinkList: ['sign_employer', 'sign_proxy_agency'],
    }, {
        title: 'POEA - Undertaking Of Employer',
        name: 'POEA - Undertaking Of Employer.pdf',
        value: 'PoeaUndertakingOfEmployer',
        signLinkList: ['sign_employer'],
    }, {
        title: 'Form B',
        name: 'Form B.pdf',
        value: 'formB',
        signLinkList: ['sign_employer', 'sign_agency'],
    }, {
        title: 'MOM Authorisation Form (For Cancellation Of Helper Replaced)',
        name: 'MOM Authorisation Form (For Cancellation Of Helper Replaced).pdf',
        value: 'MOMAuthorisationFormForCancellationOfHelperReplaced',
        signLinkList: ['sign_employer', 'sign_agency'],
    }, {
        title: 'Overlapping Letter',
        name: 'Overlapping Letter.pdf',
        value: 'overlappingLetter',
        signLinkList: ['sign_employer'],
    }, {
        title: 'Insurance Proposal Form (EQ)',
        name: 'Insurance Proposal Form (EQ).pdf',
        value: 'newEQProposalForm',
        signLinkList: ['sign_employer', 'sign_agency'],
    }, {
        title: 'Insurance Proposal Form (China Taiping)',
        name: 'Insurance Proposal Form (China Taiping).pdf',
        value: 'domesticMaidProposalForm',
        signLinkList: ['sign_employer'],
    }, {
        title: 'Renewal Declaration Form',
        name: 'Renewal Declaration Form.pdf',
        value: 'renewalDeclarationForm',
        signLinkList: ['sign_employer'],
    }, {
        title: 'Security Bond',
        name: 'Security Bond.pdf',
        value: 'securityBond',
        signLinkList: ['sign_employer', 'sign_agency', 'sign_ipa_agency'],
    }, {
        title: 'Declaration Form',
        name: 'Declaration Form.pdf',
        value: 'declarationForm',
        signLinkList: ['sign_employer', 'sign_helper', 'sign_agency', 'sign_ipa_agency'],
    }, {
        title: 'Employment Contract',
        name: 'Employment Contract.pdf',
        value: 'employmentContract',
        signLinkList: ['sign_employer', 'sign_helper', 'sign_agency', 'sign_ipa_agency'],
    }, {
        title: 'Off Day Agreement',
        name: 'Off Day Agreement.pdf',
        value: 'offDayAgreement',
        signLinkList: ['sign_employer', 'sign_helper', 'sign_agency', 'sign_ipa_agency'],
    }, {
        title: 'Form C',
        name: 'Form C.pdf',
        value: 'formC',
        signLinkList: ['sign_helper', 'sign_agency', 'sign_ipa_agency'],
    }, {
        title: 'Acknowledgement of Additional Money Deduction',
        name: 'Acknowledgement of Additional Money Deduction.pdf',
        value: 'acknowledgementOfAdditionalMoneyDeduction',
        signLinkList: ['sign_helper', 'sign_agency'],
    }, {
        title: 'Safety Agreement (Myanmar)',
        name: 'Safety Agreement (Myanmar).pdf',
        value: 'safetyAgreementMyanmar',
        signLinkList: ['sign_employer', 'sign_helper', 'sign_agency'],
    }, {
        title: 'Safety Agreement (Indonesian)',
        name: 'Safety Agreement (Indonesian).pdf',
        value: 'safetyAgreementIndonesian',
        signLinkList: ['sign_employer', 'sign_helper', 'sign_agency'],
    }, {
        title: 'Safety Agreement (Philippines)',
        name: 'Safety Agreement (Philippines).pdf',
        value: 'safetyAgreementPhilippines',
        signLinkList: ['sign_employer', 'sign_helper', 'sign_agency', 'sign_ipa_agency'],
    }, {
        title: 'Safety Agreement (India)',
        name: 'Safety Agreement (India).pdf',
        value: 'safetyAgreementIndian',
        signLinkList: ['sign_employer', 'sign_helper', 'sign_agency'],
    }, {
        title: 'FDW Orientation Checklist',
        name: 'FDW Orientation Checklist.pdf',
        value: 'FDWOrientationChecklist',
        signLinkList: ['sign_employer', 'sign_helper', 'sign_agency', 'sign_ipa_agency'],
    }, {
        title: 'FDW Personal Belongings Checklist',
        name: 'FDW Personal Belongings Checklist.pdf',
        value: 'FDWPersonalBelongingsChecklist',
        signLinkList: ['sign_employer', 'sign_helper', 'sign_agency'],
    }, {
        title: 'MOM Employment History(new, after wp issuance)',
        name: 'MOM Employment History(new, after wp issuance).pdf',
        value: 'MOMEmploymentHistoryNew',
        signLinkList: ['sign_employer', 'sign_helper', 'sign_agency', 'sign_ipa_agency'],
    }, {
        title: 'Salary Schedule',
        name: 'Salary Schedule.pdf',
        value: 'salarySchedule',
        signLinkList: ['sign_employer', 'sign_helper', 'sign_agency', 'sign_ipa_agency'],
    }, {
        title: 'Handing Over Form',
        name: 'Handing Over Form.pdf',
        value: 'handingOverForm',
        signLinkList: ['sign_employer', 'sign_helper'],
    }, {
        title: 'Customized',
        name: 'Customized.pdf',
        value: 'customized',
        signLinkList: ['sign_employer'],
    }],
    insurancePdfNameMap: [{
        title: 'Insurance Proposal Form (China Taiping)',
        name: 'Insurance Proposal Form (China Taiping).pdf',
        value: 1,
        signLinkList: [],
    }],
    supplyOnStatusMap: [{
        name: 'A - Key Customer',
        value: 1,
    }, {
        name: 'B - High Potential',
        value: 2,
    }, {
        name: 'C - Other Active',
        value: 3,
    }, {
        name: 'D - Inactive',
        value: 4,
    }, {
        name: 'Z - Black List',
        value: 5,
    }],
    creditRatingMap: [{
        name: 'A - Excellent',
        value: 1,
    }, {
        name: 'B - Very Good',
        value: 2,
    }, {
        name: 'C - Good',
        value: 3,
    }, {
        name: 'D - Fair',
        value: 4,
    }, {
        name: 'E - Poor',
        value: 5,
    }],
    agencyPriorityMap: [{
        name: 'A',
        value: 'A',
    }, {
        name: 'B',
        value: 'B',
    }, {
        name: 'C',
        value: 'C',
    }, {
        name: 'D',
        value: 'D',
    }, {
        name: 'E',
        value: 'E',
    }, {
        name: 'F',
        value: 'F',
    }, {
        name: 'G',
        value: 'G',
    }],
    agencyBindStatusMap: [{
        name: 'Requested',
        value: 0,
    }, {
        name: 'Active',
        value: 1,
    }, {
        name: 'Request Declined',
        value: 2,
    }],
    enquirySourceMap: [],
    invoicePaymentStatusMap: [{
        name: 'Paid',
        value: 1,
    }, {
        name: 'To be Paid',
        value: 0,
    }],
    completedContractMap: [],
    mmToPxRateA3: 4,
    mmToPxRateA4: 5.667,
    mmToPxRateA5: 5.667,
    pageSizeMap: [{
        name: 'A3',
        value: 'A3',
        width: 297,
        height: 420,
    }, {
        name: 'A4',
        value: 'A4',
        width: 210,
        height: 297,
    }, {
        name: 'A5',
        value: 'A5',
        width: 148,
        height: 210,
    }],
    pageLayoutMap: [{
        name: 'Portrait',
        value: 'portrait',
    }, {
        name: 'Landscape',
        value: 'landscape',
    }],
    salaryRangeRangeMap: [
        {name: '$0 - $1,999', value: '0,1999'},
        {name: '$2,000 - $2,499', value: '2000,2499'},
        {name: '$2,500 - $2,999', value: '2500,2999'},
        {name: '$3,000 - $3,499', value: '3000,3499'},
        {name: '$3,500 - $3,999', value: '3500,3999'},
        {name: '$4,000 - $4,999', value: '4000,4999'},
        {name: '$5,000 - $5,999', value: '5000,5999'},
        {name: '$6,000 - $7,999', value: '6000,7999'},
        {name: '$8,000 - $9,999', value: '8000,9999'},
        {name: '$10,000 - $12,499', value: '10000,12499'},
        {name: '$12,500 - $14,999', value: '12500,14999'},
        {name: '$15,000 - $19,999', value: '15000,19999'},
        {name: '$20,000 - $24,999', value: '20000,24999'},
        {name: 'above $25,000', value: '25000,'},
    ],
    employerIntentionAfterTerminationMap: [{
        name: 'Employer is seeking a replacement.',
        value: 1,
    }, {
        name: 'Employer will hire / has hired a helper from other agency.',
        value: 2,
    }, {
        name: `Employer doesn't need a helper anymore.`,
        value: 3,
    }, {
        name: `Employer's decision is currently unknown.`,
        value: 4,
    }],
    helperOutcomeMap: [],
    contractEmploymentStatusMap: [],
    restDayGrantedOnListMap: [],
    /**
     * 1 成功
     * 2 失败
     * 3 文件类型不匹配
     * 4 文件格式错误
     * */
    filePareTypeMap: {
        success: 1,
        fail: 2,
        typeError: 3,
        formatError: 4,
    },
    contractStatusDescListMap: [],
    excludeAnyOtherRemarkOptionalMap: [],
    petsTypeList: [],
    contractCollectTypeMap: [],
    bankMatchMap: [{
        name: 'Matched',
        value: 1,
    }, {
        name: 'To Be Matched',
        value: 0,
    }, {
        name: 'No Need Match',
        value: 2,
    }],
    measlesDeclarationMap: [{
        name: 'The MDW is already vaccinated or immune to measles (Proof of Vaccination would be update to NIR or Measles Immunity (SERO) test would be arrange)',
        value: 1,
    }, {
        name: 'All children below seven years old in the household have been fully vaccinated',
        value: 2,
    }, {
        name: 'Unsure if the MDW has been vaccinated but a vaccination or Measles Immunity (SERO) test had been / would be booked for the MDW.',
        value: 3,
    }],
    loanOrderStatusMap: [{
        name: 'Created',
        value: 1,
    }, {
        name: 'Approved',
        value: 2,
    }, {
        name: 'Loan Released',
        value: 3,
    }, {
        name: 'Cancelled',
        value: 100,
    }],
    settleStatusMap: [{
        name: 'To be Settled',
        value: 0,
    }, {
        name: 'Settled',
        value: 1,
    }],
    supplierContractStatusMap: [
        { value: 1, name: "Pending IPA Approval" },
        { value: 6, name: "OEC Processing" },
        { value: 11, name: "Pending OEC Release" },
        { value: 16, name: "Pre-Departure" },
        { value: 21, name: "Pending Departure" },
        { value: 23, name: 'Pending Close' },
        { value: 26, name: "Cancelled" },
        { value: 31, name: "Closed" },
    ],
    loanFollowUpResultMap: [{
        name: 'No Need Postpone',
        value: 0,
    }, {
        name: 'Need Postpone',
        value: 1,
    }],
    loanHelperStatusMap: [{
        value: 1,
        name: '01_All Good',
    }, {
        value: 2,
        name: '02_Problem - In coordination',
    }, {
        value: 3,
        name: '03_Problem - Transfer',
    }, {
        value: 4,
        name: '04_Problem - Repat',
    }, {
        value: 5,
        name: '05_Problem - Repat (Reconstruct Payment)',
    }, {
        value: 6,
        name: '06_Problem - Not contactable',
    }, {
        value: 7,
        name: '07_Problem - Refuse to pay',
    }, {
        value: 8,
        name: '08_Problem - Collection Agency',
    }, {
        value: 9,
        name: '09_Problem - File to court',
    }],
    loanCollectionStageMap: [{
        value: 1,
        name: 'Reminder1',
    }, {
        value: 2,
        name: 'Reminder2',
    }, {
        value: 3,
        name: 'Reminder3',
    }, {
        value: 4,
        name: 'Demand1',
    }, {
        value: 5,
        name: 'Demand2',
    }, {
        value: 6,
        name: 'Collection Agency',
    }, {
        value: 7,
        name: 'File to Court',
    }],
    loanChequeHandlingMap: [{
        value: 1,
        name: 'On Hold',
    }, {
        value: 2,
        name: 'Can Deposit',
    }, {
        value: 4,
        name: 'Successful Deposit',
    }, {
        value: 3,
        name: 'Deposit Cheque Bounced',
    }],
    languageForSipIndian: ['English', 'Tamil', 'Malayalam', 'Telegu', 'Hindi', 'Punjabi', 'Mizo'],
    languageForSipSriLankan: ['Tamil', 'Sinhalese', 'English'],
    contractCaseTypeMap: [{
        name: 'Ordinary',
        value: 1,
    }, {
        name: 'Direct Hire',
        value: 6,
    }],
    trainingOrderStatusMap: [{
        name: 'Created',
        value: 1,
    }, {
        name: 'Training in Process',
        value: 2,
    }, {
        name: 'Training Completed',
        value: 3,
    }, {
        name: 'Closed',
        value: 4,
    }, {
        name: 'Terminated',
        value: 5,
    }, {
        name: 'Cancelled',
        value: 6,
    }],
    trainingPaymentOptionsMap: [{
        name: 'Cash',
        value: 1,
        key: 'cash',
    }, {
        name: 'Finance Loan from ICare',
        value: 2,
        key: 'financeLoanFromIcare',
    }, {
        name: 'Finance Loan from PJH',
        value: 3,
        key: 'financeLoanFromJph',
    }, {
        name: 'Finance Loan from Balikbayad',
        value: 4,
        key: 'financeLoanFromBalikbayad',
    }, {
        name: 'Finance Loan from Other Lending Company',
        value: 5,
        key: 'financeLoanFromOtherLendingCompany',
    }, {
        name: 'Personal Loan from Employer',
        value: 6,
        key: 'financeLoanFromEmployer',
    }, {
        name: 'Personal Loan from Others',
        value: 7,
        key: 'financeLoanFromOthers',
    }],

    hkResidentialTypeMap: [],
    hkHelperFacilitiesMap: [],
    helperTimelineEventMap: [],
    interviewAvailabilityMap: [],
    interviewAvailabilityFilterMap: [],
    contractTypeMap: [],
    placeOfOriginMapForPh: ['Abra', 'Agusan del Norte', 'Agusan del Sur', 'Aklan', 'Albay', 'Antique', 'Apayao', 'Aurora', 'Basilan', 'Bataan', 'Batanes', 'Batangas', 'Benguet', 'Biliran', 'Bohol', 'Bukidnon', 'Bulacan', 'Cagayan', 'Camarines Norte', 'Camarines Sur', 'Camiguin', 'Capiz', 'Catanduanes', 'Cavite', 'Cebu', 'Cotabato (North Cotabato)', 'Davao de Oro', 'Davao del Norte', 'Davao del Sur', 'Davao Occidental', 'Davao Oriental', 'Dinagat Islands', 'Eastern Samar', 'Guimaras', 'Ifugao', 'Ilocos Norte', 'Ilocos Sur', 'Iloilo', 'Isabela', 'Kalinga', 'La Union', 'Laguna', 'Lanao del Norte', 'Lanao del Sur', 'Leyte', 'Maguindanao del Norte', 'Maguindanao del Sur', 'Marinduque', 'Masbate', 'Metro Manila (NCR)', 'Misamis Occidental', 'Misamis Oriental', 'Mountain Province', 'Negros Occidental', 'Negros Oriental', 'Northern Samar', 'Nueva Ecija', 'Nueva Vizcaya', 'Occidental Mindoro', 'Oriental Mindoro', 'Palawan', 'Pampanga', 'Pangasinan', 'Quezon', 'Quirino', 'Rizal', 'Romblon', 'Samar (Western Samar)', 'Sarangani', 'Siquijor', 'Sorsogon', 'South Cotabato', 'Southern Leyte', 'Sultan Kudarat', 'Sulu', 'Surigao del Norte', 'Surigao del Sur', 'Tarlac', 'Tawi-Tawi', 'Zambales', 'Zamboanga del Norte', 'Zamboanga del Sur', 'Zamboanga Sibugay'],
    placeOfOriginMapForId: ['Jawa Timur', 'Jawa Tengah', 'Jawa Barat', 'Nusa Tenggara Barat', 'Nusa Tenggara Timur', 'Lampung', 'Aceh', 'Sumatera Utara', 'Sumatera Barat', 'Riau', 'Kepulauan Riau', 'Jambi', 'Bengkulu', 'Sumatera Selatan', 'Kepulauan Bangka Belitung', 'DKI Jakarta', 'Banten', 'DI Yogyakarta', 'Bali', 'Kalimantan Barat', 'Kalimantan Tengah', 'Kalimantan Selatan', 'Kalimantan Timur', 'Kalimantan Utara', 'Sulawesi Utara', 'Gorontalo', 'Sulawesi Tengah', 'Sulawesi Barat', 'Sulawesi Selatan', 'Sulawesi Tenggara', 'Maluku', 'Maluku Utara', 'Papua Barat', 'Papua Barat Daya', 'Papua Tengah', 'Papua Pegunungan', 'Papua Selatan', 'Papua'],
    placeOfOriginMapForMm: ['Bago', 'Yangon', 'Ayeyarwady', 'Kayin', 'Mandalay', 'Magway', 'Mon', 'Chin', 'Shan', 'Sagaing', 'Tanintharyi', 'Kachin', 'Kayah', 'Rakhine', 'Naypyidaw'],
    placeOfOriginMapForTh: ['Udon Thani', 'Nakhon Ratchasima', 'Khon Kaen', 'Chiang Mai', 'Chiang Rai', 'Buriram', 'Ubon Ratchathani', 'Roi Et', 'Surin', 'Sisaket', 'Sakon Nakhon', 'Chaiyaphum', 'Kalasin', 'Maha Sarakham', 'Nong Khai', 'Nong Bua Lamphu', 'Loei', 'Nakhon Phanom', 'Mukdahan', 'Bueng Kan', 'Yasothon', 'Amnat Charoen', 'Lampang', 'Lamphun', 'Phrae', 'Nan', 'Phayao', 'Mae Hong Son', 'Uttaradit', 'Bangkok', 'Phitsanulok', 'Nakhon Sawan', 'Phetchabun', 'Sukhothai', 'Kamphaeng Phet', 'Phichit', 'Uthai Thani', 'Phra Nakhon Si Ayutthaya', 'Saraburi', 'Lopburi', 'Suphan Buri', 'Nakhon Pathom', 'Pathum Thani', 'Nonthaburi', 'Samut Prakan', 'Samut Sakhon', 'Samut Songkhram', 'Ang Thong', 'Chai Nat', 'Sing Buri', 'Nakhon Nayok', 'Kanchanaburi', 'Ratchaburi', 'Tak', 'Phetchaburi', 'Prachuap Khiri Khan', 'Chonburi', 'Rayong', 'Chanthaburi', 'Chachoengsao', 'Prachinburi', 'Sa Kaeo', 'Trat', 'Phuket', 'Surat Thani', 'Nakhon Si Thammarat', 'Songkhla', 'Krabi', 'Phang Nga', 'Trang', 'Ranong', 'Chumphon', 'Phatthalung', 'Satun', 'Pattani', 'Yala', 'Narathiwat'],
    offDayArrangementMap: [],
    pjOrderStatusMap: [
        {name: 'Order Created', value: 1},
        {name: 'Order Confirmed', value: 2},
        {name: 'Order in Progress', value: 16},
        {name: 'Picked Up', value: 3},
        {name: 'Medical Completed', value: 12},
        {name: 'SIP in Progress', value: 13},
        {name: 'SIP Completed', value: 14},
        {name: 'Handover Completed', value: 15},
        {name: 'Pending WP Issuance', value: 4},
        {name: 'WP Issued', value: 5},
        {name: 'Thumbprint Scheduled', value: 6},
        {name: 'Completed', value: 7},
        {name: 'Cancelled', value: 8},
        {name: 'Terminated', value: 9},
        {name: 'Declined', value: 10},
    ],

    salaryMinList: [450, 460, 470, 480, 490, 500, 510, 520, 530, 540, 550, 560, 570, 580, 590, 600, 600, 610, 620, 630, 640, 650, 660, 670, 680, 690, 700,
        710, 720, 730, 740, 750, 760, 770, 780, 790, 800, 810, 820, 830, 840, 850, 860, 870, 880, 890, 900, 910, 920, 930, 940, 950, 960, 970, 980, 990, 1000],

    salaryMaxList: [450, 460, 470, 480, 490, 500, 510, 520, 530, 540, 550, 560, 570, 580, 590, 600, 600, 610, 620, 630, 640, 650, 660, 670, 680, 690, 700,
        710, 720, 730, 740, 750, 760, 770, 780, 790, 800, 810, 820, 830, 840, 850, 860, 870, 880, 890, 900, 910, 920, 930, 940, 950, 960, 970, 980, 990, 1000],

}
